import { defineStore } from "pinia";
import { handleError } from "@/utils/common.js";
import { authData } from "@/api/apiService";
import { NOTIFICATIONS, NOTIFICATIONS_CATEGORIES } from "@/api/apiRoute";
import { errorMessage } from "@/utils/errorMessages";

export const useNotificationStore = defineStore("notificationStore", {
  state: () => ({
    errorDisplayDuration: 4000,
    errorMsg: "",
    loading: false,
    notifications: [],
    notificationCategories: [],
  }),
  getters: {
    newNotificationsCount: (state) =>
      state.notifications
        ? state.notifications.filter((n) => n.status === "new").length
        : 0,
  },
  actions: {
    clearErrorMessage() {
      this.errorMsg = "";
    },
    setErrorMessage(error) {
      this.errorMsg = errorMessage[error] || error || "An error occurred";
    },
    showError(error) {
      this.setErrorMessage(error?.response?.data?.error);
      setTimeout(() => {
        this.clearErrorMessage();
      }, this.errorDisplayDuration);
      handleError(error);
      throw error;
    },
    async getNotifications(filter = "") {
      this.loading = true;
      try {
        const result = await authData.get(`${NOTIFICATIONS}${filter}`);
        this.notifications = result?.data?.data || [];
        return result;
      } catch (error) {
        this.showError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async getNotificationCategories() {
      this.loading = true;
      try {
        const result = await authData.get(`${NOTIFICATIONS_CATEGORIES}`);
        this.notificationCategories = result?.data?.data || [];
        return result;
      } catch (error) {
        this.showError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async updateNotification(id, data) {
      this.loading = true;
      try {
        const result = await authData.patch(`${NOTIFICATIONS}/${id}`, data);
        await this.getNotifications();
        return result;
      } catch (error) {
        this.showError(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
  },
});
